export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      <img
        src="https://static.readdy.ai/image/f77f6aa78adb73f9994f91e3447ad68f/d0632e8e3262f3b3991bde2b29d19e68.jpeg"
        alt="hero background"
        className="absolute inset-0 w-full h-full object-cover object-center scale-150"
        style={{ transformOrigin: 'center center' }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/35 to-black/10"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="max-w-3xl -mt-20">
          <div className="inline-block mb-6">
            <span className="px-4 py-2 bg-white/15 text-white border border-white/30 rounded-full text-sm font-semibold backdrop-blur-sm">
              Welcome to Noah's Portfolio
            </span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Hi, I'm Noah
          </h1>
          
          <p className="text-xl md:text-2xl text-white/80 mb-8 leading-relaxed">
            Creative Designer &amp; Developer crafting beautiful digital experiences with passion and precision. Specializing in web design, development, and creative solutions that bring ideas to life.
          </p>
          
          <div className="flex flex-wrap gap-4">
            <button 
              onClick={() => scrollToSection('projects')}
              className="px-8 py-4 bg-gradient-to-r from-teal-500 to-teal-400 text-white rounded-full hover:shadow-xl transition-all cursor-pointer font-semibold text-lg whitespace-nowrap"
            >
              View My Work
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="px-8 py-4 bg-white/15 text-white rounded-full border-2 border-white/60 hover:bg-white hover:text-gray-900 transition-all cursor-pointer font-semibold text-lg whitespace-nowrap backdrop-blur-sm"
            >
              Get In Touch
            </button>
          </div>

          <div className="mt-12 flex items-center gap-8">
            <div>
              <div className="text-4xl font-bold text-white">4</div>
              <div className="text-white/70 font-medium">Projects Completed</div>
            </div>
            <div className="w-px h-12 bg-white/30"></div>
            <div>
              <div className="text-4xl font-bold text-white"></div>
              <div className="text-white/70 font-medium"></div>
            </div>
            <div className="w-px h-12 bg-white/30"></div>
            <div>
              <div className="text-4xl font-bold text-white">1+</div>
              <div className="text-white/70 font-medium">Years Experience</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button 
          onClick={() => scrollToSection('about')}
          className="w-10 h-10 flex items-center justify-center text-white/70 cursor-pointer"
        >
          <i className="ri-arrow-down-line text-2xl"></i>
        </button>
      </div>
    </section>
  );
}
